import React from 'react';
import Paper from '@mui/material/Paper';
import { useMutation, useQuery } from '@apollo/client';
import GenericTable from '../../components/genericTable';
import { useNavigate } from 'react-router-dom';
import { DELETE_CONTRACT, GET_ALL_CONTRACTS } from '../../gql/contracts';
import usePermissions from '../../hooks/usePermissions';

const columnsOptions = {
  id: {
    hide: true,
  },
  product_tier: {
    headerName: 'Tier',
  },
  partner: {
    headerName: 'Parceiro',
    valueGetter: ({ value }: Record<any, any>) => value?.tradingName || 'N/A',
  },
  product: {
    headerName: 'Produto',
    valueGetter: ({ value }: Record<any, any>) => value?.name || 'N/A',
  },
  paymentType: {
    headerName: 'Tipo de Pagamento',
    valueGetter: ({ value }: Record<any, any>) => value || 'N/A',
  },
  dueDates: {
    headerName: 'Data de Vencimento',
    valueGetter: ({ value }: Record<any, any>) => value || 'N/A',
  },
  dollarValue: {
    headerName: 'Valor do Dólar',
    valueGetter: ({ value }: Record<any, any>) => (value ? value.toFixed(4) : 'N/A'),
  },
  dollarType: {
    headerName: 'Tipo de Dólar',
    valueGetter: ({ value }: Record<any, any>) => value || 'N/A',
  },
};

const ContractsRoute = () => {
  const navigate = useNavigate();
  const { isAdmin } = usePermissions();

  const { data, loading } = useQuery(GET_ALL_CONTRACTS);
  const [deleteContract] = useMutation(DELETE_CONTRACT, {
    refetchQueries: [{ query: GET_ALL_CONTRACTS }],
  });

  const handleEditContract = ({ id = '' }: { id?: string }) =>
    navigate(`/dashboard/contracts/${id}`);
  const handleDeleteContract = ({ id = '' }) => deleteContract({ variables: { id } });

  return (
    <Paper sx={{ width: '100%', mb: 2 }}>
      <GenericTable
        data={data?.getAllContracts}
        loading={loading}
        columnOptions={columnsOptions}
        onEdit={handleEditContract}
        onDelete={handleDeleteContract}
        hideDeleteButton={!isAdmin}
      />
    </Paper>
  );
};

export default ContractsRoute;
